export default "__VITE_ASSET__CsbMvMQj__"